import type { DefaultError, MutationObserverOptions, MutationOptions } from "@tanstack/vue-query";

import { useMutation } from "@tanstack/vue-query";
import { type MaybeRef, toValue } from "vue";

type MaybeRefDeep<T> = MaybeRef<
  T extends Function
    ? T
    : T extends object
      ? {
          [Property in keyof T]: MaybeRefDeep<T[Property]>;
        }
      : T
>;

export type V4BMutationOpts<
  ResponseType = unknown,
  ErrorType = DefaultError,
  VariablesType = unknown,
  ContextType = unknown,
> = Omit<MutationOptions<ResponseType, ErrorType, VariablesType, ContextType>, "mutationKey" | "mutationFn">;

export function useV4bMutation<TData = unknown, TError = DefaultError, TVariables = void, TContext = unknown>(
  mutationOptions: MaybeRefDeep<MutationObserverOptions<TData, TError, TVariables, TContext>>,
) {
  const opts = toValue(mutationOptions);

  const mutation = useMutation<TData, TError, TVariables, TContext>({
    ...opts,
    onError: (error, variables, onMutateResult, context) => {
      const onError = opts.onError;
      if (onError && typeof onError === "function") {
        onError(error, variables, onMutateResult, context);
      }
    },
  });

  return {
    ...mutation,
  };
}
